import Box from './box';

export default Box;